// src/components/HomeSlot.js
import React, { useEffect, useRef, useState } from 'react';
import '../styles/HomeSlot.css';
import locImage from '../assets/loc.png';

const HomeSlot = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const imageEl = imageRef.current;
    const textEl = textRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (imageEl) observer.observe(imageEl);
    if (textEl) observer.observe(textEl);

    return () => {
      if (imageEl) observer.unobserve(imageEl);
      if (textEl) observer.unobserve(textEl);
    };
  }, []);

  return (
    <section className="home-slot">
      <div className="home-slot-content">
        <div
          ref={imageRef}
          className={`home-slot-image ${inView ? 'fade-left' : ''}`}
        >
          <img src={locImage} alt="Location Icon" />
        </div>
        <div
          ref={textRef}
          className={`home-slot-text ${inView ? 'fade-right' : ''}`}
        >
          <h2 className="home-slot-title">
            SHADE
          </h2>
          <p>
            <strong>Shade</strong> is a bike pooling app designed specifically for students and IT professionals, allowing users to
share his/her bike ride with others heading to the similar destinations.The app aims to reduce traffic
congestion, lower transportation costs, foster new friendships with like-minded people ,and minimize
carbon emissions by decreasing the number of vehicles on the road. Whether you're heading to class or
the office, SHADE enhances your ride with both social and financial benefits.</p>
        </div>
      </div>
    </section>
  );
};

export default HomeSlot;
